import React, { useEffect, useState } from 'react'
import Service from '../../services'
import { getFromSession } from '../../helpers/GenericHelpers';

type Props = {}
const user_id = getFromSession('user_id');
const WorkSpacePage = (props: Props) => {
    const [workSpaceData, setWorkSpaceData] = useState<any>()
    const service = new Service();
    useEffect(()=>{
        service.get_workspace_details(user_id).then((response:any)=>{
            console.log(response?.data)
            setWorkSpaceData(response?.data)
        }).catch((error:any)=>{
            console.log(error)
        })
    },[])
  return (
    <>
    <div className="landing-main">
    <div className="gen-background"></div>
    <div className="project-list-main">
            {workSpaceData && workSpaceData?.length > 0 ? (
              workSpaceData?.map((ele:any) => (
                <div className='proj-main-card draft' style={{marginTop:'200px'}}>
                    {ele?.workspace_name}
                </div>
              ))
            ) : (
              <div className="not-found">No records available</div>
            )}
    </div>
    {/* <div className="gen-title">
      <div className="new-proj">
        <div className="left">Solutions Dashboard</div>
        <div className="right">
          <div className="search-box">
            <input
              type="text"
              className="search-input"
              placeholder="Search"
              value={projectSearch}
              onChange={(e) => handleSearch(e?.target?.value)}
            />
            <FontAwesomeIcon icon={faSearch} className="search-icon" />
          </div>
          <Button onClick={toggleWorkSpaceModal} className="create-project work-space">
            <FontAwesomeIcon icon={faPlus} /> Create Work Space
          </Button>
          <Button onClick={toggleNewModal} className="create-project">
            <FontAwesomeIcon icon={faPlus} /> Create New
          </Button>
        </div>
      </div>
    </div> */}

   
  </div>
  </>
  )
}

export default WorkSpacePage